<div *ngIf="model" class="info-block">
    <div class="block">
        <div class="inner-info-row">
            <div class="nova__label" [ngClass]="'flex-' + labelFlex">Candidate</div>
            <div [ngClass]="'flex-' + dataFlex" class="data-col">
                <a class="nova__link"
                href="{{model.candidateLink}}"
                target="_blank" rel="noopener">{{model.candidateName}}</a>
            </div>
        </div>

        <div class="inner-info-row">
            <div class="nova__label" [ngClass]="'flex-' + labelFlex">Facility</div>
            <div [ngClass]="'flex-' + dataFlex" class="data-col">
                <a class="nova__link"
                routerLink="{{model.facilityLink}}"
                target="_blank" rel="noopener">{{model.facilityName}}</a>
                <mat-icon *ngIf="infoBubbleNote?.length>0" class="info-bub" data-qa-id="info_bubble_billing_note_perm_offer"
                    [novaMultiLineTooltip]="infoBubbleNote" >info
                </mat-icon>
            </div>
        </div>

        <ng-container>
            <div class="inner-info-row" *ngIf="isClinical && model.unitName">
                <div class="nova__label" [ngClass]="'flex-' + labelFlex">Unit</div>
                <div [ngClass]="'flex-' + dataFlex" class="data-col">
                    <a class="nova__link"
                    (click)="openUnitFormUrl($event, model.unitLink)" target="_blank" rel="noopener">{{model.unitName}}</a>
                </div>
            </div>
        </ng-container>

        <div class="inner-info-row">
            <div class="nova__label" [ngClass]="'flex-' + labelFlex">Job</div>
            <div [ngClass]="'flex-' + dataFlex" class="data-col">
                <a class="nova__link bold"
                routerLink="{{model.jobLink}}"
                target="_blank" rel="noopener">{{model.jobName}}</a>
            </div>
        </div>

        <div class="inner-info-row" *ngIf="isClinical && (model.matchPercentage || model.matchPercentage === 0)">
            <div class="nova__label" [ngClass]="'flex-' + labelFlex">
                Match Rating
            </div>
            <div class="data-col">
                <span class="dot" [ngClass]="model.matchColor"></span>
                <span> {{model.matchCategory }} Match</span>
            </div>
        </div>
    </div>
</div>
